import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

import { useManagedContext } from "../../components/hooks";
import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading, FooterButtonVolver } from '../../components/common';
import TipoActoProcesalModal from '../../components/controls/TipoActoProcesalModal';
import { useAccess } from '../../components/hooks/useAccess';
import { standardRequest } from '../../utils/requests';

function TiposActosProcesalesView() {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        addChildren: false,
        rowId: 0,
        list: []
    });
    
    const [plantillasDocumentos, setPlantillasDocumentos] = useState([]);

    const [search] = useSearchParams();
    const [hasEditAccess, setHasEditAccess] = useState(false);
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;

    const allowEditActions = hasEditAccess && !isViewOnly;

    const mount = () => {

        SearchTiposActosProcesales();
        SearchPlantillasDocumentos();
        
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    useAccess({
        key: 'TiposActosProcesalesView',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
            else setHasEditAccess(data.some(x => x.codigo === 'apremio_edit'))
        }
    });

    //definiciones
    const cellA = (props) => !allowEditActions ? '' : (
        <div className='action'>
            <div onClick={ (event) => handleClickTipoActoProcesalAdd() } className="link">
                <span className="material-symbols-outlined" title="Nuevo">add</span>
            </div>
        </div>
    )
    const cellVMR = (props) => (
        <div className='action'>
            <div onClick={ (event) => handleClickTipoActoProcesalView(props.value) } className="link">
                <span className="material-symbols-outlined" title="Ver">search</span>
            </div>
            {allowEditActions && <>
                <div onClick={ (event) => handleClickTipoActoProcesalModify(props.value) } className="link">
                <span className="material-symbols-outlined" title="Modificar">stylus</span>
                </div>
                <div onClick={ (event) => handleClickTipoActoProcesalRemove(props.value) } className="link">
                <span className="material-symbols-outlined" title="Eliminar">delete</span>
                </div>
                <div onClick={ (event) => handleClickTipoActoProcesalAddChildren(props.value) } className="link">
                    <span className="material-symbols-outlined" title="Nuevo acto">note_add</span>
                </div>
            </>}
        </div>
    )
    
    const tableColumns = [
        { Header: 'Tipo acto procesal', Cell: (props) => {
            const row = props.row.original;

            let prefijo = "";
            const espacio = "\u00A0\u00A0\u00A0";
            const flecha =  (<span className="material-symbols-outlined">subdirectory_arrow_right</span>);

            if (row.nivel > 1){ prefijo = (
            <>
                <span>{espacio.repeat(row.nivel - 1)}</span>
                {flecha}
            </>)}

            const renglon =
            <div>
                <span>
                    {prefijo}{row.codigoActoProcesal} - {row.descripcion}
                </span>
            </div>

            return renglon;
          }, accessor: 'tipoActoProcesal', width: '90%' }, 
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '1%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickTipoActoProcesalAdd = () => {
        setState(prevState => {
            return {...prevState, showForm: true, modeFormEdit: true, rowId: 0, addChildren: false};
        });
    }
    const handleClickTipoActoProcesalView = (id) => {
        setState(prevState => {
            return {...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id), addChildren: false};
        });
    }
    const handleClickTipoActoProcesalModify = (id) => {
        setState(prevState => {
            return {...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id), addChildren: false};
        });        
    }
    const handleClickTipoActoProcesalRemove = (id) => {
        const item = state.list.find(x => x.id === id)
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Seguro de borrar el acto procesal ${item.descripcion}?`,
            onConfirm: () => {
                setIsLoading(true)
                standardRequest(REQUEST_METHOD.DELETE, `${APIS.URLS.TIPO_ACTO_PROCESAL}/${id}`)
                .then(() => SearchTiposActosProcesales())
                .catch(() => {})
                .finally(() => setIsLoading(false))
            }
        })
    }
    const handleClickTipoActoProcesalAddChildren = (id) => {
        setState(prevState => {
            return {...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id), addChildren: true};
        });
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchTiposActosProcesales() {
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [] }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                setIsLoading(false)
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };


        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ACTO_PROCESAL,
            null,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchPlantillasDocumentos() {
        setIsLoading(true)
        setPlantillasDocumentos([]);

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                setIsLoading(false)
                setPlantillasDocumentos(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            null,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
    <>
        {state.showForm && 
            <TipoActoProcesalModal
                id={state.rowId}
                disabled={!allowEditActions || !state.modeFormEdit}
                addChildren={state.addChildren}
                list={plantillasDocumentos}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });
                    SearchTiposActosProcesales();
                }}
            />
        }

        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url:'/entidades' }, { title: 'Tipos de actos procesales' }]} 
                        onAddClick={allowEditActions ? handleClickTipoActoProcesalAdd : null} />

        <section className='section-accordion'>

            <div className="m-top-20">

                <TableCustom
                    className={'TableCustomTree'}
                    columns={tableColumns}
                    data={state.list}
                />

            </div>

        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
        
    </>
    )
}

export default TiposActosProcesalesView;
